import { ShopwareProduct } from '@services/types/Shopware';

export function ucfirst(str: string): string {
    if (!str) return str; // Return empty string if input is empty
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function newportRounding(n: number): number {
    return n > Math.floor(n) + 0.6 ? Math.ceil(n) : Math.floor(n);
}

export function dateFormat(date: Date): string {
    if (!(date instanceof Date) || isNaN(date?.getTime())) {
        console.warn('Unknown date input', date);
        return '(unknown date)';
    }

    return date.toISOString().split('T')[0];
}

export function isInteger(value: number | string): boolean {
    if (typeof value === 'number') {
        return Number.isInteger(value);
    }

    const num = Number(value);
    return value.trim() !== '' && Number.isInteger(num);
}

export function getSeoUrl(product: ShopwareProduct) {
    if (!product?.seoUrls?.[0]) {
        return `/detail/${product.id}`;
    }

    return `/${product.seoUrls[0].seoPathInfo}`;
}

export function getManufacturer(product: ShopwareProduct): string | null {
    const manufacturer = product?.manufacturer;
    return manufacturer ? manufacturer?.translated?.name || manufacturer?.name : null;
}

export function getManufacturerLink(product: ShopwareProduct): string | null {
    const manufacturer = product?.manufacturer;
    // @ts-ignore
    const customFields = manufacturer?.translated?.customFields || manufacturer?.customFields;
    const id = customFields?.custom_manufacturer_inspiration || null;

    if (id) {
        return `/navigation/${id}`;
    }

    return null;
}

export function base64Encode(str: string): string {
    if (typeof Buffer !== 'undefined') {
        return Buffer.from(str, 'utf-8').toString('base64');
    }

    const encoder = new TextEncoder();
    const uint8Array = encoder.encode(str);
    const binaryString = Array.from(uint8Array)
        .map(byte => String.fromCharCode(byte))
        .join('');
    return btoa(binaryString);
}

export function base64Decode(base64: string): string {
    if (typeof Buffer !== 'undefined') {
        return Buffer.from(base64, 'base64').toString('utf-8');
    }

    const binaryString = atob(base64);
    const bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0));
    const decoder = new TextDecoder();
    return decoder.decode(bytes);
}
